<template>
  <login-layout v-if="client_config.client_id" :style="brandColours">

    <form class="t-login__form" @submit.prevent >
      <div class="t-login__field">
        <label for="email" class="control-label">Email:</label>
        <input
          class="form-control"
          id="email"
          type="email"
          name="email"
          v-model="email"
          autofocus />
        <span class="help-block" v-if="errorMessages.email">{{ errorMessages.email }}</span>
      </div>

      <div v-if="token" class="t-login__field"  >
        <label for="password" class="control-label">Password:</label>
        <input
          id="password"
          type="password"
          class="form-control"
          name="password"
          v-model="password"/>
        <span class="help-block" v-if="errorMessages.password">{{ errorMessages.password }}</span>
      </div>

      <div v-if="token" class="t-login__field"  >
        <label for="confirm-password" class="control-label">Confirm Password:</label>
        <input
          id="confirm-password"
          type="password"
          class="form-control"
          name="password"
          @paste.prevent
          v-model="passwordConfirmation"/>
        <span class="help-block" v-if="errorMessages.passwordConfirmation">{{ errorMessages.passwordConfirmation }}</span>
      </div>

      <ladda-button
        ref="search"
        class="btn btn-dark"
        type="submit"
        :click="handleSubmit">
        Activate your account
      </ladda-button>
    </form>

  </login-layout>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import { notify } from 'utils'
import LoginLayout from './auth/LoginLayout'
import {required, sameAs, minLength, helpers as validationHelpers} from 'vuelidate/lib/validators'
import cssVars from 'css-vars-ponyfill'

const tinycolor = require('tinycolor2')

export default {
  data () {
    return {
      email: '',
      password: '',
      passwordConfirmation: ''
    }
  },

  props: {
    token: {
      type: String,
      default: null
    }
  },

  components: {
    LoginLayout
  },

  validations () {
    if (this.token) {
      return {
        email: {
          required
        },
        password: {
          required,
          minLength: minLength(6),
          passwordRules: validationHelpers.regex('passwordRules', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)
        },
        passwordConfirmation: {
          sameAsPassword: sameAs('password')
        }
      }
    }

    return {
      email: {
        required
      }
    }
  },

  created () {
    this.getClientConfig().then(response => {
      window.document.title = response.data.tenant_details.application_name
      cssVars({
        variables: this.brandColours
      })
    })
  },

  computed: {
    ...mapState('clientConfig', ['client_config']),

    notificationMarkup () {
      return `
        Download App - <a href="https://onelink.to/spaces" target="_blank">click to download</a> app,\n\n
         Enter <b>${this.client_config.tenant_details.client_domain}</b> and click “Get Started”. Then log in using email and password to sign in`
    },

    brandColours () {
      return {
        '--brand-primary': this.client_config.colours.brand_primary,
        '--brand-primary-light': tinycolor ? tinycolor(this.client_config.colours.brand_primary).lighten(10).toString() : null,
        '--brand-primary-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_primary).lighten(25).toString() : null,
        '--brand-primary-dark': tinycolor ? tinycolor(this.client_config.colours.brand_primary).darken(10).toString() : null,
        '--brand-primary-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_primary).darken(25).toString() : null,
        '--brand-secondary': this.client_config.colours.brand_info,
        '--brand-secondary-light': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(10).toString() : null,
        '--brand-secondary-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(25).toString() : null,
        '--brand-secondary-dark': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(10).toString() : null,
        '--brand-secondary-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(25).toString() : null,
        '--brand-info': this.client_config.colours.brand_info,
        '--brand-info-light': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(10).toString() : null,
        '--brand-info-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(25).toString() : null,
        '--brand-info-dark': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(10).toString() : null,
        '--brand-info-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(25).toString() : null,
        '--brand-vlast': this.client_config.colours.brand_vlast,
        '--brand-vlast-light': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).lighten(10).toString() : null,
        '--brand-vlast-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).lighten(25).toString() : null,
        '--brand-vlast-dark': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).darken(10).toString() : null,
        '--brand-vlast-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).darken(25).toString() : null,
        '--brand-vlast-text': this.client_config.colours.brand_vlast_text,
        '--brand-vlast-text-light': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).lighten(10).toString() : null,
        '--brand-vlast-text-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).lighten(25).toString() : null,
        '--brand-vlast-text-dark': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).darken(10).toString() : null,
        '--brand-vlast-text-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).darken(25).toString() : null,
        '--brand-text': this.client_config.colours.brand_text,
        '--brand-text-light': tinycolor ? tinycolor(this.client_config.colours.brand_text).lighten(10).toString() : null,
        '--brand-text-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_text).lighten(25).toString() : null,
        '--brand-text-dark': tinycolor ? tinycolor(this.client_config.colours.brand_text).darken(10).toString() : null,
        '--brand-text-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_text).darken(25).toString() : null,
        '--brand-success': '#5cb85c',
        '--brand-success-light': tinycolor ? tinycolor('#5cb85c').lighten(10).toString() : null,
        '--brand-success-lightest': tinycolor ? tinycolor('#5cb85c').lighten(25).toString() : null,
        '--brand-success-dark': tinycolor ? tinycolor('#5cb85c').darken(10).toString() : null,
        '--brand-success-darkest': tinycolor ? tinycolor('#5cb85c').darken(25).toString() : null,
        '--brand-danger': '#d9534f',
        '--brand-danger-light': tinycolor ? tinycolor('#d9534f').lighten(10).toString() : null,
        '--brand-danger-lightest': tinycolor ? tinycolor('#d9534f').lighten(25).toString() : null,
        '--brand-danger-dark': tinycolor ? tinycolor('#d9534f').darken(10).toString() : null,
        '--brand-danger-darkest': tinycolor ? tinycolor('#d9534f').darken(25).toString() : null,
        '--brand-warning': '#f0ad4e',
        '--brand-warning-light': tinycolor ? tinycolor('#f0ad4e').lighten(10).toString() : null,
        '--brand-warning-lightest': tinycolor ? tinycolor('#f0ad4e').lighten(25).toString() : null,
        '--brand-warning-dark': tinycolor ? tinycolor('#f0ad4e').darken(10).toString() : null,
        '--brand-warning-darkest': tinycolor ? tinycolor('#f0ad4e').darken(25).toString() : null,
        '--brand-default': '#ccc',
        '--brand-default-light': tinycolor ? tinycolor('#ccc').lighten(10).toString() : null,
        '--brand-default-lightest': tinycolor ? tinycolor('#ccc').lighten(25).toString() : null,
        '--brand-default-dark': tinycolor ? tinycolor('#ccc').darken(10).toString() : null,
        '--brand-default-darkest': tinycolor ? tinycolor('#ccc').darken(25).toString() : null
      }
    },

    errorMessages () {
      let errors = {}

      const messages = {
        email: {
          required: 'Email Address is required.'
        },
        password: {
          required: 'A password is required.',
          minLength: 'Passwords must be at least 6 characters.',
          passwordRules: 'Password must contain a lowercase letter, an uppercase letter and a number.'
        },
        passwordConfirmation: {
          sameAsPassword: 'The password confirmation field does not match.'
        }
      }

      if (!this.$v.$error) { return errors }

      for (const [field, fieldMessages] of Object.entries(messages)) {
        if (!this.$v[field] || !this.$v[field].$invalid) continue

        for (const [rule, ruleMessage] of Object.entries(fieldMessages)) {
          if (this.$v[field][rule] === false) {
            errors[field] = ruleMessage
            break
          }
        }
      }

      return errors
    }

  },

  methods: {
    ...mapActions('user', ['resetPassword', 'updatePassword']),
    ...mapActions('clientConfig', ['getClientConfig']),

    handleSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }

      if (this.token) {
        return this.updatePassword({
          activateAccount: true,
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }).then(() => {
          notify.success(this.notificationMarkup,
            {timeout: false,
              closeWith: ['button']
            })
          this.$router.push({ name: 'login' })
        }).catch((e) => {
          notify.error((e.response && e.response.data.message) ? e.response.data.message : 'Unable to update password for that email address.')
        })
      } else {
        notify.error('Invalid link.')
      }
    }
  }
}
</script>
